var constants = require('../constants');
var surveyStateHistoryConstants = require('../../surveyStateHistory/constants');

const initialState = {
    isFetching: false,
    error: {},
    currentResponse: [],
    submission: []
};

var responses = function(state, action) {
    state = state || initialState;

    switch (action.type) {
        case constants.SET_CURRRENT_RESPONSE:
            return Object.assign({}, state, {
                currentResponse: action.data
            });
        case constants.SUBMIT_RESPONSE:
            return Object.assign({}, state, {
                submission: [...state.submission, action.data],
                error: {}
            });
        case constants.CLEAR_CURRRENT_RESPONSE:
            return Object.assign({}, state, {
                currentResponse: []
            });
        case constants.REPLACE_CURRRENT_RESPONSE:
            return Object.assign({}, state, {
                currentResponse: action.data
            });
        case constants.SUBMISSION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            });
        case constants.SUBMISSION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                error: {}
            });
        case constants.SUBMISSION_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        case constants.SET_RESPONSE_VALIDATION_ERROR:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        case constants.CLEAR_RESPONSE_VALIDATION_ERROR:
            return Object.assign({}, state, {
                error: {}
            });
        case surveyStateHistoryConstants.GO_PREVIOUS_SURVEY_STATE:
            return Object.assign({}, state, action.previousSurveyState.responses);
        default:
            return state;
    }
}

module.exports = responses;



// WEBPACK FOOTER //
// ./src/common/modules/responses/reducers/responses.js